export default function getToday() {
  const today = new Date(new Date().getTime() - 1000 * 60 * 60 * 3)
  const todayString = today.toISOString()
  const returnToday = todayString.replace(/T.*$/, 'T00:00:00.000Z')
  return returnToday
}